import * as React from 'react'

import history from '@/utils/history'
import cn from '@/utils/tailwind/cn'

function FormScreenContainer({ children }) {
  const formOfficeUse = history.location.pathname.includes(
    'fillFormOfficeUseQuestions'
  )

  const packetOfficeUse = history.location.pathname.includes(
    'fillPacketOfficeUseQuestions'
  )

  const officeMode = formOfficeUse || packetOfficeUse

  const containerStyles = {
    'h-[calc(100svh-148px)] min-h-[calc(100svh-148px)]': officeMode,
  }
  return (
    <div
      className={cn(
        'form-wrapper flex-column flex min-h-screen w-full justify-between',
        containerStyles
      )}
    >
      {children}
    </div>
  )
}

export default FormScreenContainer
